import React, { Component, Fragment } from 'react'
import {
    Button,
    Modal, ModalBody, ModalFooter,
    ModalHeader
} from 'reactstrap'
import autobind from 'autobind-decorator'
import { connect } from 'react-redux'
import * as categories from 'catalog/actions/categories'
import Select from 'react-select';

@connect(
    state => ({
        categoryList: state.categories.categoryList,
        activeCategory: state.categories.activeCategory
    }),
    dispatch => ({
        update: (category) => dispatch(categories.updateSubcategory(category)),
        fetchSubcategoryList: () => dispatch(categories.fetchSubcategoryList()),
        chooseCategory: (category) => dispatch(categories.chooseCategory(category)),
    })
)
export default class MoveCategory extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
            target: null
        }
    }

    @autobind
    toggle() {
        const isOpen = !this.state.isOpen
        this.setState({ isOpen })
    }

    @autobind
    confirm() {
        const {update, category, chooseCategory} = this.props;
        const {target} = this.state;
        if(target) {
            update({
                ...category,
                parent: target.id
            });
            chooseCategory(target);
            this.toggle();    
        }
    }

    render() {
        const {
            isOpen
        } = this.state
        const {
            categoryList,
            activeCategory
        } = this.props
        return (
            <Fragment>
                <Button color='primary' title='Kategorie verschieben'
                    onClick={this.toggle}>
                    <i className='fa fa-arrows-alt'> </i>
                </Button>
                <Modal isOpen={isOpen}>
                    <ModalHeader>
                        Kategorie verschieben
                                </ModalHeader>
                    <ModalBody>
                        <Select options={categoryList.filter(el => el.id !== activeCategory.id).map(el => ({
                            value: el,
                            label: el.name
                        }))} onChange={option=>this.setState({target: option.value})} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color='danger'
                            onClick={this.confirm}>Bestätigen</Button>
                        <Button color='default'
                            onClick={this.toggle}>Abbrechen</Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}
